export const SCP_CLOUD_BACKEND = 0;
export const GAM_BACKEND = 1;
export const UAM_BACKEND = 2;
